import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './router/permission'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './icons' // icon
import "default-passive-events";
import '@/assets/style/index.scss' // global css
import 'highlight.js/styles/stackoverflow-light.css'
import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript'
import hljsVuePlugin from "@highlightjs/vue-plugin";
import directive from '@/directive/index'
import VueUeditorWrap from 'vue-ueditor-wrap';
hljs.registerLanguage('typescript', typescript);

const pinia = createPinia()
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(hljsVuePlugin)
app.use(pinia)
app.use(router)
app.use(VueUeditorWrap)
directive(app)
app.mount('#app')
